import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, ModalInfo, MultiRadio } from 'shared/components';
import { REQUEST_UPDATE_TYPE } from 'shared/constants';
import {
  RequestUpdateData,
  CancelRequestUpdate,
  RequestRescheduleEvent,
  CloseTestCenter,
} from 'features/request-update';
import { get, isEmpty, isUndefined } from 'lodash';
import './RequestUpdateContainer.scss';
import PendingIcon from 'assets/svgs/pendingIcon.svg';

const getTypeList = (t) => [
  {
    key: 'option-update-event',
    label: t('requestUpdate.updateEventOption'),
    value: 'update-event',
  },
  {
    key: 'option-close-tc',
    label: t('requestUpdate.closeTCOption'),
    value: 'close-tc',
  },
  {
    key: 'option-reschedule',
    label: t('requestUpdate.rescheduleOption'),
    value: 'reschedule',
  },
];

class RequestUpdateContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedType: '',
      typeModalOpen: false,
      dataModalOpen: false,
      rescheduleModalOpen: false,
      closeTCModalOpen: false,
      requestUpdateTab: '',
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.showCloseModal = this.showCloseModal.bind(this);
    this.onRequestUpdateTypeChange = this.onRequestUpdateTypeChange.bind(this);
    this.onContinue = this.onContinue.bind(this);
    this.toggleTypeModal = this.toggleTypeModal.bind(this);
    this.openRequestUpdateTab = this.openRequestUpdateTab.bind(this);
    this.openBlockedRequestModal = this.openBlockedRequestModal.bind(this);
  }

  openBlockedRequestModal(type) {
    switch (type) {
      case REQUEST_UPDATE_TYPE.closeTcEvent:
        this.toggleModal('closeTCModalOpen');
        break;
      case REQUEST_UPDATE_TYPE.rescheduleTcEvent:
        this.toggleModal('rescheduleModalOpen');
        break;
      default:
        break;
    }
  }

  toggleTypeModal() {
    const { currentRequest } = this.props;

    if (!isEmpty(currentRequest) && currentRequest.type !== REQUEST_UPDATE_TYPE.eventUpdate) {
      this.openBlockedRequestModal(currentRequest.type);
    } else {
      this.setState((prevState) => ({
        selectedType: prevState.typeModalOpen ? '' : prevState.selectedType || 'update-event',
        typeModalOpen: !prevState.typeModalOpen,
        requestUpdateTab: '',
      }));
    }
  }

  openRequestUpdateTab(tabName) {
    const { currentRequest } = this.props;

    if (!isEmpty(currentRequest) && currentRequest.type !== REQUEST_UPDATE_TYPE.eventUpdate) {
      this.openBlockedRequestModal(currentRequest.type);
    } else {
      this.setState({
        requestUpdateTab: tabName,
        dataModalOpen: true,
      });
    }
  }

  toggleModal(modal, backToType = false) {
    this.setState((prevState) => ({
      selectedType: backToType && prevState.selectedType ? prevState.selectedType : '',
      [modal]: !prevState[modal],
      typeModalOpen: !!prevState.selectedType && backToType,
      requestUpdateTab: '',
    }));
  }

  onRequestUpdateTypeChange(e) {
    const { value } = e.target;

    this.setState({
      selectedType: value,
    });
  }

  onContinue() {
    const { selectedType } = this.state;

    switch (selectedType) {
      case 'update-event':
        this.setState({
          typeModalOpen: false,
          dataModalOpen: true,
          closeTCModalOpen: false,
          requestUpdateTab: 'capacity',
        });
        break;
      case 'reschedule':
        this.setState({
          typeModalOpen: false,
          rescheduleModalOpen: true,
          closeTCModalOpen: false,
        });
        break;
      case 'close-tc':
        this.setState({
          typeModalOpen: false,
          dataModalOpen: false,
          rescheduleModalOpen: false,
          closeTCModalOpen: true,
        });
        break;
      default:
        break;
    }
  }

  showCloseModal() {
    this.setState({
      dataModalOpen: false,
      closeTCModalOpen: true,
    });
  }

  render() {
    const { closeTCModalOpen, typeModalOpen, dataModalOpen, selectedType, rescheduleModalOpen } =
      this.state;

    const {
      tcEvent,
      requestUpdateTab,
      currentRequest,
      testCenterCycle,
      allEventLocations,
      showPending,
      user,
    } = this.props;

    let editTab = 'shipping';
    if (!isEmpty(currentRequest)) {
      if (!isEmpty(get(currentRequest, 'data.eventUpdate.locationEvents'))) {
        editTab = 'capacity';
      } else if (!isUndefined(get(currentRequest, 'data.eventUpdate.message'))) {
        editTab = 'admission';
      }
    }

    return (
      !isEmpty(tcEvent) && (
        <div className="request-update">
          <div className="buttons-section">
            {!testCenterCycle.testCenterProgram.testCenter.nowManagedFlag && (
              <Button
                type="btn-primary"
                className="btn-small request-update-btn"
                text={this.props.t('requestUpdate.buttonLabel')}
                onClick={this.toggleTypeModal}
              />
            )}

            {showPending && (
              <button
                className="btn btn-small request-update-edit-btn"
                onClick={() => this.openRequestUpdateTab(editTab)}
                data-bs-toggle="popover"
                data-bs-placement="top"
                data-bs-trigger="hover"
                data-bs-content={this.props.t('requestUpdate.pending.infoMessage')}>
                <PendingIcon />
                {this.props.t('requestUpdate.pending.editBtn')}
              </button>
            )}

            <CancelRequestUpdate
              testingEventId={tcEvent.testingEvent.id}
              tcId={testCenterCycle.testCenterProgram.testCenter.id}
              locations={allEventLocations}
            />
          </div>

          <ModalInfo
            containerClass="modal-update-request-type-container"
            className="modal-update-request-type"
            modalIsOpen={typeModalOpen}
            closeModal={this.toggleTypeModal}
            onSubmit={this.onContinue}
            headerTitle={this.props.t('requestUpdate.title')}
            saveLabel={this.props.t('common.labels.continue')}
            cancelLabel={this.props.t('common.labels.back')}
            showCancel>
            <div>
              <h4 className="mb-4">{tcEvent.testingEvent.name}</h4>
              <MultiRadio
                radioList={getTypeList(this.props.t)}
                checkedValue={selectedType}
                onChange={this.onRequestUpdateTypeChange}
                title={this.props.t('requestUpdate.selectTypeMessage')}
              />
            </div>
          </ModalInfo>

          <RequestUpdateData
            dataModalOpen={dataModalOpen}
            activeTab={this.state.requestUpdateTab || requestUpdateTab}
            toggleModal={(back = false) => this.toggleModal('dataModalOpen', back)}
            showCloseModal={this.showCloseModal}
            userId={user.id}
          />

          <CloseTestCenter
            modalIsOpen={closeTCModalOpen}
            testingEventId={tcEvent.testingEvent.id}
            tcId={testCenterCycle.testCenterProgram.testCenter.id}
            toggleModal={(back = false) => this.toggleModal('closeTCModalOpen', back)}
            userId={user.id}
          />
          <RequestRescheduleEvent
            rescheduleModalOpen={rescheduleModalOpen}
            toggleModal={(back = false) => this.toggleModal('rescheduleModalOpen', back)}
            userId={user.id}
          />
        </div>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users.currentUser || {},
    tcEvent: state.tcEvent.currentEvent || {},
    testCenterCycle: state.tcEvent.testCenterCycle || {},
    currentRequest: state.requestUpdate.currentRequest,
    allEventLocations: state.tcEvent.allEventLocations,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({}, dispatch) };
}

export default withTranslation(undefined, { withRef: true })(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(RequestUpdateContainer)
);

RequestUpdateContainer.propTypes = {
  tcEvent: PropTypes.shape({
    id: PropTypes.number,
    testingEvent: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    message: PropTypes.string,
  }),
  testCenterCycle: PropTypes.shape({
    testCenterProgram: PropTypes.shape({
      testCenter: PropTypes.shape({
        id: PropTypes.number,
        nowManagedFlag: PropTypes.bool,
      }),
    }),
  }),
  currentRequest: PropTypes.shape({
    type: PropTypes.string,
    data: PropTypes.shape({
      eventUpdate: PropTypes.shape({
        locationEvents: PropTypes.arrayOf(PropTypes.shape({})),
        message: PropTypes.string,
      }),
    }),
  }),
  allEventLocations: PropTypes.arrayOf(PropTypes.shape({})),
  requestUpdateTab: PropTypes.string,
  showPending: PropTypes.bool,
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
  actions: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

RequestUpdateContainer.defaultProps = {};
